    angular.module('errorInterceptor', ['toastr'])
        .config(function ($httpProvider) {
            $httpProvider.interceptors.push('errorInterceptor');
        })
        .factory('errorInterceptor', function ($q, toastr, $window) {
            return {
                'responseError': function (rejection) {
                    if (rejection.status === 503 || rejection.status === 500 || rejection.status === 400 || rejection.status === 404 || rejection.status === 403 || rejection.status === 409) {

                        if (angular.isArray(rejection.data.messages)) {
                            angular.forEach(rejection.data.messages, (message, key) => toastr.error(message));
                        }

                    }
                    if(rejection.headers('X-ProxyPass-Status') === 'maintenance'){
                        $window.location.reload();
                    }
                    return $q.reject(rejection);
                }
            }
        });
